// extracted by mini-css-extract-plugin
export default {"Container":"CheckBox_Container__kln1-","Box":"CheckBox_Box__TAz3u","BoxActive":"CheckBox_BoxActive__8EJAA","Label":"CheckBox_Label__oBkU4"};